import { Pipe, PipeTransform } from '@angular/core';

import { Observable } from 'rxjs';
import { delay } from 'rxjs/operators';

@Pipe({
  name: 'finDelay',
})
export class DelayPipe implements PipeTransform {
  transform(input: any, delayInMilliSeconds = 1): Observable<any> {
    if (input && input instanceof Observable) {
      return input.pipe(delay(delayInMilliSeconds));
    }
    return input;
  }
}
